import z from 'zod';

export const invoiceChargeTypeOptions = [
  { name: 'All Charge Types', value: 'mixed' },
  { name: 'One-Time', value: 'one-time' },
  { name: 'Recurring', value: 'recurring' },
];

export const invoiceChargeTypeValues = new Set<string>(invoiceChargeTypeOptions.map((option) => option.value));
export const invoiceChargeTypeSchema = z.enum(['one-time', 'recurring', 'mixed']);
